import { __assign, __read, __rest } from "tslib";
import React from 'react';
import { cx } from 'emotion';
import _ from 'lodash';
import { SegmentSelect } from './SegmentSelect';
import { useExpandableLabel } from '.';
import { useAsyncFn } from 'react-use';
import { getSegmentStyles } from './styles';
import { InlineLabel } from '../Forms/InlineLabel';
import { useStyles } from '../../themes';
export function SegmentAsync(_a) {
    var _b;
    var _c;
    var value = _a.value, onChange = _a.onChange, loadOptions = _a.loadOptions, Component = _a.Component, className = _a.className, allowCustomValue = _a.allowCustomValue, disabled = _a.disabled, placeholder = _a.placeholder, rest = __rest(_a, ["value", "onChange", "loadOptions", "Component", "className", "allowCustomValue", "disabled", "placeholder"]);
    var _d = __read(useAsyncFn(loadOptions, [loadOptions]), 2), state = _d[0], fetchOptions = _d[1];
    var _e = __read(useExpandableLabel(false), 4), Label = _e[0], width = _e[1], expanded = _e[2], setExpanded = _e[3];
    var styles = useStyles(getSegmentStyles);
    if (!expanded) {
        var label = _.isObject(value) ? value.label : value;
        return (React.createElement(Label, { onClick: fetchOptions, disabled: disabled, Component: Component || (React.createElement(InlineLabel, { className: cx(styles.segment, (_b = {},
                    _b[styles.queryPlaceholder] = placeholder !== undefined && !value,
                    _b[styles.disabled] = disabled,
                    _b), className) }, label || placeholder)) }));
    }
    return (React.createElement(SegmentSelect, __assign({}, rest, { value: value && !_.isObject(value) ? { value: value } : value, options: (_c = state.value) !== null && _c !== void 0 ? _c : [], width: width, noOptionsMessage: mapStateToNoOptionsMessage(state), allowCustomValue: allowCustomValue, onClickOutside: function () {
            setExpanded(false);
        }, onChange: function (item) {
            setExpanded(false);
            onChange(item);
        } })));
}
function mapStateToNoOptionsMessage(state) {
    if (state.loading) {
        return 'Loading options...';
    }
    if (state.error) {
        return 'Failed to load options';
    }
    if (!Array.isArray(state.value) || state.value.length === 0) {
        return 'No options found';
    }
    return '';
}
//# sourceMappingURL=SegmentAsync.js.map